
import Navigation from '../components/utils/Navigation';
import NoDataAvailable from "../components/utils/NoDataAvailable.vue";
import { deleteGroup } from '../utils/entityMethods/group';
import { populateUsefulMaps } from '../utils/entityMethods/ticket.js';
import { waitSeconds } from '../utils/utilitiesmodule';
export default {
    name: "Groups",
    props: {
        idGroup: String
    },
    components: {
        Navigation,
        NoDataAvailable
    },
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.hash != "" && to.hash.endsWith("/delete")) {
                    var groupID = to.hash.split("/")[0].replace("#", "");
                    var group = this.$session.getGroups().find(g => g.id_group == groupID);
                    this.deleteGroup(group);
                    return;
                }
                if (to.hash != "") {
                    var id_group = to.hash.replace("#", "");
                    this.openDialogGroup(id_group)
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            groups: null,
            filters: {
                strToSearch: "",
                id_customer: ""
            },
            customers: null

        }
    },
    async mounted() {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);
        await this.populateUsefulMaps();
        this.customers = Object.values(this.$root.customerMap);
        this.groups = this.$session.getGroups();
        let self = this;
        this.$root.$on("refreshGroups", async () => {
            self.groups.clear();
            await waitSeconds(0.1);
            self.groups.update(await this.$api.getGroups());
            self.$session.setGroups(self.groups);
        });
    },
    unmounted: function () {
        this.$root.$off("refreshGroups");
    },
    methods: {
        populateUsefulMaps,
        getGroups(applyFilters) {

            if (applyFilters) {
                var strToSearch_toLower = this.filters.strToSearch.toLowerCase();
                var f1, f2;
                this.groups.update(this.$session.getGroups().filter(p => {
                    f1 = ["", p.id_customer].includes(this.filters.id_customer);
                    if (!f1) {
                        return false;
                    }
                    f2 = this.filters.strToSearch == '' ||
                        p.name_group.toLowerCase().contains(strToSearch_toLower) ||
                        (p.address_group && p.address_group.toLowerCase().contains(strToSearch_toLower)) ||
                        (p.email_group && p.email_group.toLowerCase().contains(strToSearch_toLower)) ||
                        (p.notes_group && p.notes_group.toLowerCase().contains(strToSearch_toLower));

                    return f2

                }
                ));
                return;
            }

            this.$api.getGroups().then(async groups => {
                this.groups = null;
                this.groups = groups;
                this.$session.setGroups(this.groups);
            });
        },

        logNavigation(event) {
            //console.log('Navigating to:', { name: 'Group', params: { idGroup: this.group.id_group } });
        },

        async openDialogGroup(id_group) {
            var group = await this.$api.getGroup(id_group);
            if (group) {
                this.$root.$emit("OPENGROUPVIEWDIALOG", group);
            }
        },

        deleteGroup

    }
}
